import { render, staticRenderFns } from "./ScholarshipsDetails.vue?vue&type=template&id=8a0a05b6"
import script from "./ScholarshipsDetails.vue?vue&type=script&lang=js"
export * from "./ScholarshipsDetails.vue?vue&type=script&lang=js"
import style0 from "./ScholarshipsDetails.vue?vue&type=style&index=0&id=8a0a05b6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports